import type { AssetMapSimpleProps } from "./asset-map-simple.type";

import {
  MapInteractive,
  parseLatLngString,
  createMapMarker,
} from "@/modules/map";

const AssetMapSimple = ({ asset, context }: AssetMapSimpleProps) => {
  const { coordinate } = asset;
  const mapId = `${context}_${asset?.id}`;
  const mapCoordinates = parseLatLngString({ coordinate });
  const marker = createMapMarker({
    key: mapId,
    position: mapCoordinates,
  });
  if (!marker) return null;

  return (
    <MapInteractive
      id={mapId}
      markers={[marker]}
      sizes={{ ratio: "16:9" }}
      noInfoWindow
    />
  );
};

export default AssetMapSimple;
